/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { S as Switch, d as defineCustomElement$1 } from './switch.js';

const CalciteSwitch = Switch;
const defineCustomElement = defineCustomElement$1;

export { CalciteSwitch, defineCustomElement };

//# sourceMappingURL=calcite-switch.js.map